import {NgClass} from '@angular/common';
import {Component, Input, OnChanges, SecurityContext, SimpleChanges, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'nlr-dropdown',
    imports: [NgClass],
    templateUrl: './nlr-dropdown.component.html',
    styleUrl: './nlr-dropdown.component.scss'
})
export class NlrDropdownComponent implements OnChanges {
    @Input() items = [];
    @Input() mark: string;
    @ViewChild('dropdownList') dropdownList;
    caseSensitive = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectedItem = new BehaviorSubject<any>(undefined);
    highlightedIndex: number = 0;

    constructor(private readonly sanitizer: DomSanitizer) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items']) {
            this.highlightedIndex = this.items.length > 0 ? 0 : -1;
        }
    }

    clearHighlight() {
        this.highlightedIndex = -1;
    }

    highlightItem(index: number) {
        this.highlightedIndex = index;
    }

    highlightNext() {
        this.highlightedIndex++;
        if (this.highlightedIndex >= this.items.length) {
            this.highlightedIndex = 0;
        }
        this.scrollCurrentItem();
    }

    highlightPrevious() {
        this.highlightedIndex--;
        if (this.highlightedIndex < 0) {
            this.highlightedIndex = Math.max(this.items.length - 1, 0);
        }
        this.scrollCurrentItem();
    }

    scrollCurrentItem() {
        if (!this.dropdownList || !this.items) {
            return;
        }
        const listElement = this.dropdownList.nativeElement;
        if (listElement.scrollHeight > listElement.offsetHeight) {
            listElement.scrollTop = (listElement.scrollHeight / this.items.length) * this.highlightedIndex;
        }
    }

    formatOutput(origin: string) {
        const regex = new RegExp(this.mark, this.caseSensitive ? 'g' : 'gi');
        const newText = origin.replace(regex, (match: string) => {
            return `<b>${match}</b>`;
        });
        return this.sanitizer.sanitize(SecurityContext.HTML, newText);
    }

    selectItem(value) {
        console.log('You click:', value);

        this.selectedItem.next(value);
    }

    selectCurrentItem() {
        if (this.items.length > this.highlightedIndex) {
            this.selectedItem.next(this.items[this.highlightedIndex]);
        }
    }

    hide = () => {
        return this.items.length < 1;
    };
}
